var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[(_vm.name)?_c('img',{attrs:{"src":require("@/assets/home/logo_logined@2x.png")}}):_c('img',{attrs:{"src":require("@/assets/home/logo_unlogin@2x.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }